module.exports = __webpack_public_path__ + "img/fb-icon.a2f85653.svg";